import * as v from 'valibot';

export const botFlagSchema = v.pipe(
  v.string('bot flag must be a boolean string'),
  v.transform(value => value === '1'),
  v.boolean(),
);

export const botScoreSchema = v.pipe(
  v.string('botScore must be a numeric string'),
  v.transform(Number),
  v.number('botScore must be a valid number'),
  v.finite('botScore must be finite'),
);
